import React from 'react';
import { CJEvent } from '@teetsh/app/src/types/event';
import { BOLabels } from '@teetsh/app/src/types/user';
import { Tag } from '@teetsh/app/src/components/Tag';
import 'twin.macro';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { ClassroomsOrg } from '@teetsh/app/src/types/school';
import { HoraireComponent } from 'containers/CahierJournal/DayColumn/Seance/Horaire';
import { CJEventBody } from 'containers/CahierJournal/DayColumn/Seance/CJEventBody';
import { useEventCustomFieldDefinitionsContext } from 'containers/App/context/EventCustomFieldDefinitionsContext/EventCustomFieldDefinitionsProvider';
import { TitleLine } from 'containers/CahierJournal/DayColumn/Seance/CJEventBody/TitleLine';

interface Props {
  event: CJEvent;
  condensed: boolean;
  boLabels: BOLabels;
  classroomsOrg: ClassroomsOrg;
  collapsed: boolean;
}

export function Classic(props: Props) {
  const { event, boLabels, condensed, classroomsOrg, collapsed } = props;
  const { start, end } = event;
  const user = useUser();
  const { definitions: customFieldDefinitions } =
    useEventCustomFieldDefinitionsContext();

  return (
    <>
      <div tw="flex flex-wrap">
        <HoraireComponent tw="pl-4" start={start} end={end} />
        <div tw="flex items-center flex-grow justify-end">
          {event.tag ? (
            <Tag
              color={event.tag.color}
              tw="self-start ml-1 break-words overflow-hidden items-start min-h-[1rem]"
            >
              {event.tag.title}
            </Tag>
          ) : (
            <div />
          )}
        </div>
      </div>
      <div tw="pb-2 px-4 flex justify-between">
        <TitleLine
          collapsed={collapsed}
          classroomsOrg={classroomsOrg}
          event={event}
        />
        <CJEventBody
          onChange={() => {}}
          hidden={collapsed}
          userId={user.id}
          customFieldDefinitions={customFieldDefinitions}
          isGuest={user.guestMode?.enabled}
          print={false}
          event={event}
          boLabels={boLabels}
          condensed={condensed}
        />
      </div>
    </>
  );
}
